'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: '请选择时间'
};
exports["default"] = locale;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/time-picker/locale/zh_CN.tsx
 ** module id = 151
 ** module chunks = 0
 **/